import PromoCodeContainer from './PromoCodeContainer';

export default PromoCodeContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage/components/PromoCode/index.js